import { createRoutine } from 'redux-saga-routines';

export const setRoleRoutine = createRoutine('SET_ROLE');

export const resetRoleRoutine = createRoutine('RESET_ROLE');

export const fetchContactRoutine = createRoutine('FETCH_CONTACT');

export const fetchReferencesRoutine = createRoutine('FETCH_REFERENCES');
export const fetchCandidateDataRoutine = createRoutine('FETCH_CANDIDATE_DATA');
export const changeCandidatePositionRoutine = createRoutine('CHANGE_CANDIDATE_POSITION');
export const saveContactInfoRoutine = createRoutine('SAVE_CONTACT_INFO');
export const setContactInfoErrorRoutine = createRoutine('SET_CONTACT_INFO_ERROR');
export const resetContactIsSavedRoutine = createRoutine('RESET_CONTACT_IS_SAVED');

export const fetchCandidatesByContactRoutine = createRoutine('FETCH_CANDIDATES_CONTACT');

export const updateProspectStatusRoutine = createRoutine('UPDATE_PROSPECT_STATUS');

export const updateRefStatusRoutine = createRoutine('UPDATE_REF_STATUS');
